"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelCase = camelCase;
exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.getInitialsFromName = void 0;
exports.ordinalSuffixOf = ordinalSuffixOf;
exports.roundIfNeeded = roundIfNeeded;
exports.validateEmail = exports.textTruncate = void 0;
function preserveCamelCase(str) {
  var isLastCharLower = false;
  var isLastCharUpper = false;
  var isLastLastCharUpper = false;
  for (var i = 0; i < str.length; i++) {
    var c = str[i];
    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = "".concat(str.substr(0, i), "-").concat(str.substr(i));
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = "".concat(str.substr(0, i - 1), "-").concat(str.substr(i - 1));
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }
  return str;
}
function camelCase(str) {
  if (arguments.length > 1) {
    str = Array.from(arguments).map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x.length;
    }).join('-');
  } else {
    str = str.trim();
  }
  if (str.length === 0) {
    return '';
  }
  if (str.length === 1) {
    return str.toLowerCase();
  }
  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }
  var hasUpperCase = str !== str.toLowerCase();
  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }
  return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
    return p1.toUpperCase();
  });
}
function roundIfNeeded(number, decimalPlaces) {
  return number === Math.round(number) ? number : number.toFixed(decimalPlaces);
}
var getInitialsFromName = exports.getInitialsFromName = function getInitialsFromName(firstName, lastName) {
  var firstInitial = firstName ? firstName.split('')[0].toUpperCase() : '';
  var lastInitial = lastName ? lastName.split('')[0].toUpperCase() : '';
  return "".concat(firstInitial).concat(lastInitial);
};
function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return '';
}
function ordinalSuffixOf(i) {
  var j = i % 10;
  var k = i % 100;
  if (j === 1 && k !== 11) {
    return "".concat(i, "st");
  }
  if (j === 2 && k !== 12) {
    return "".concat(i, "nd");
  }
  if (j === 3 && k !== 13) {
    return "".concat(i, "rd");
  }
  return "".concat(i, "th");
}
var textTruncate = exports.textTruncate = function textTruncate() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var ending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';
  if (str === null) {
    return;
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  }
  return str;
};
var validateEmail = exports.validateEmail = function validateEmail(email) {
  if (email.length > 0) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  return false;
};